.container {
    max-width: 80rem;
    margin: 0 auto;
    padding-bottom: 4.5rem;
  }
  
  .containerMaxWidth {
    margin: 0 auto;
    padding: 1.875rem 1.5rem;
  }
  
  .mainRow {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 1.5rem;
  }
  .mainRowActionArea {
    padding-top: 0.5rem;
  }
  
  .leftArea {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 18.5rem;
    max-width: 18.5rem;
  }
  
  .rightArea {
    width: 100%;
    flex-direction: column;
  }
  .rightAreaNoPadding {
    composes: rightArea;
    padding: 0;
  }
  .inlineRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
    white-space: nowrap;
  }
  .actionRow {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1rem 1.25rem;
    transition: all 100ms ease-in-out;
  }
  .actionRow img {
    border-radius: 0.375rem;
  }
  .actionRowInner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
  
  }
  .actionRow[data-mode="hover"] {
    border: none;
    width: 100%;
    .actionRowActionArea {
      opacity: 0;
      visibility: hidden;
    }
  }
  .actionRow[data-mode="hover"]:hover {
    background: var(--secondary-hover);
  }
  .actionRow[data-mode="hover"]:hover .actionRowActionArea {
    opacity: 1;
    visibility: visible;
  }
  .actionRow[data-variant="inline"] {
    border-bottom: 1px solid var(--static-divider-standard);
  }
  .actionRow[data-variant="inline"]:not(:first-child):not(:last-child) {
    border-radius: unset;
  }
  .actionRow[data-variant="inline"]:not(:last-child) {
    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;
  }
  
  .actionRowLeftArea {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
    align-items: center;
  }
  .actionRowActionArea {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    transition: all 100ms ease-in-out;
  }
  .actionRowText {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  .actionRowTextLabelInactive {
    composes: actionRowTextLabel;
  }
  .actionRowTextDescription {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  .itemRowInverse {
    display: flex;
  }
  .footer {
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    padding: 1.25rem 1rem;
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: var(--static-divider-standard);
    margin: 1.5rem 0;
  }
  .spaceSmall {
    padding-bottom: 0.75rem;
  }
  .space {
    padding-bottom: 1.5rem;
  }
  